export function getValidParent(container, cssClass) {
  if (!cssClass) {
    return document;
  }

  var parent = container.parentElement;

  if (parent) {
    if (Array.from(parent.classList).find(function (clss) {
      return clss.includes(cssClass);
    })) {
      return parent;
    } else {
      return getValidParent(parent, cssClass);
    }
  }

  return document;
}